module.exports = __webpack_public_path__ + "img/jiachouji.6b055dc7.jpg";